import * as types from './types'

export const selectCategory = (item) => ({
    type: types.SELECT_CATEGORY,
    item
})